export class DocumentTemplate {
    public code: string;
    public documentTemplateId: number;
    public name: string;
    public status: boolean;
    public description: string;
    public isDraft: boolean;
    public id: string;
    public serviceType: number;
    public realm: number;
    public configFlowSignList?: []
    public typeTemplateDocument?: string
    public static build(): DocumentTemplate {
        const documentTemplate: DocumentTemplate = new DocumentTemplate();
        documentTemplate.code = null;
        documentTemplate.documentTemplateId = null;
        documentTemplate.name = null;
        documentTemplate.status = null;
        documentTemplate.description = null;
        documentTemplate.isDraft = null;
        documentTemplate.id = null;
        documentTemplate.serviceType = null;
        documentTemplate.realm = null;
        return documentTemplate;
    }
}
